import { Grid } from "@mui/material";
import React, { useRef, useEffect } from "react";
import { IoLocationSharp } from "react-icons/io5";

const AutoComplete = ({ Location, setLocation, placeholder, height,iconSize,disable }) => {
  // type,index,name,index2,handleShipments,value
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const options = {
    componentRestrictions: { country: "NG" },
  };
  useEffect(() => {
    GetWorld();
  }, []);
  const GetWorld = async () => {
    try {
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        options
      );
      await autoCompleteRef.current.addListener(
        "place_changed",
        async function () {
          const place = await autoCompleteRef.current.getPlace();
          if (place.formatted_address) {
            if (place.address_components) {
              let datasss = place.address_components;
              const street = place.address_components[0].long_name;
              const city = place.address_components?.find((item) =>
                item.types.includes("locality")
              );
              const province = place.address_components.find((item) =>
                item.types.includes("administrative_area_level_1")
              );
              var modifiedAddress = place.formatted_address.replace(/’/g, " ");
              modifiedAddress = modifiedAddress.replace(/'/g, " ");
              if(modifiedAddress){
                await setLocation({
                  Street: street,
                  city: city?.long_name,
                  Postcode:
                    place.address_components[datasss?.length - 1].long_name,
                  state: province?.long_name,
                  Address: modifiedAddress,
                });
              }
            }
          }
        }
      );
    } catch (Err) {
      console.log("Err in google autocomplete", Err);
    }
  };
  return (
    <Grid
      container
      lg={12}
      style={{ width: "100%", justifyContent: "space-between", zIndex: 199, border: "1px solid  #666666",borderRadius:"10px" }}
      className="d-flex rounded  p-1 align-items-center"
      display={"flex"}
      flexDirection={"row"}
      flexWrap={"nowrap"}
      bgcolor={"#fff"} >
      <Grid item lg={11} display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <input
          style={{
            border: "1px solid  #666666",
            height: height ? height : "38px",
            fontFamily: "PoppinsMedium",
            fontSize: "14px",
            color: "#000",
            backgroundColor: "#fff",
            width:"100%",
            // borderRadius:"20px"
          }}
          className="border-0 poppinsMedium mx-2"
          id={"jobLocation"}
          value={Location}
          disabled={disable? disable:false}
          onChange={(e) => setLocation(e.target.value)}
          autoComplete="false"
          placeholder={placeholder ? placeholder : "Enter Location"}
          ref={inputRef}
        />
      </Grid>
      <Grid item display={"flex"} justifyContent={"flex-end"}>
        <IoLocationSharp className={`text-muted ${iconSize?iconSize:"mx-2"}`}/>
      </Grid>
    </Grid>
  );
};
export default AutoComplete;
